export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
